<template>
  <Popup
    :value="showModal"
    popup-header="Multi-lingual"
    popup-size="sm"
    @input="handlePopupVisibility"
    @close="handlePopupVisibility(false)"
  >
    <div>
      <div class="text-body mb-16">Select the required languages:</div>
      <div class="flex flex-col flex-wrap h-368 md:h-256">
        <Checkbox
          v-for="(item, index) in languageOptions"
          :key="index"
          v-model="selectedLanguages"
          :labelName="item.textLabel"
          :value="item.value"
          class="w-1/2 md:w-1/3"
        />
      </div>
      <Button
        id="clear-selections"
        value="Clear All"
        class="w-full button-medium"
        variant="outlined"
        @click.prevent="clearLanguages"
      />
      <Button id="save-selections" value="Save" class="w-full button-medium my-32" @click.prevent="saveLanguages" />
    </div>
  </Popup>
</template>

<script lang="ts">
import { LanguageOption, languageOptions } from './types/languageOptions';
import Button from '@/components/button/Button.vue';
import Checkbox from '@/components/checkbox/Checkbox.vue';
import Popup from '@/components/popup/Popup.vue';
import { Languages } from '@/store/modules/job/types';

export default {
  name: 'RequirementsMultilingual',
  components: {
    Button,
    Checkbox,
    Popup,
  },
  props: {
    hideModal: Boolean,
    languages: {
      type: Array as () => Languages[],
      default: () => [],
    },
  },
  data() {
    return {
      selectedLanguages: this.languages,
    };
  },
  computed: {
    languageOptions(): LanguageOption[] {
      return languageOptions;
    },
    showModal(): boolean {
      return !this.hideModal;
    },
  },
  mounted() {
    this.escapeHandler = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        this.handlePopupVisibility(false);
      }
    };
    window.addEventListener('keydown', this.escapeHandler);
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.escapeHandler);
  },
  methods: {
    handlePopupVisibility(value: boolean) {
      this.$emit('hideModal', !value);
    },
    updateLanguages(newLanguages: string[]) {
      this.$emit('update:languages', newLanguages);
    },
    clearLanguages() {
      this.selectedLanguages = [];
      this.updateLanguages([]);
    },
    saveLanguages() {
      this.updateLanguages(this.selectedLanguages);
      this.handlePopupVisibility(false);
    },
  },
};
</script>
